/**
 * What the headhunter's volunteer leg recorded about a member
 * (quest_candidates.volunteer_history, 20260922140000). They COMPLETED a $0
 * task for the same creator, or one sharing a skill with this $0 quest.
 *
 * It is evidence for the admin, and it is not a contact permission. Only
 * admin_invite_member_to_volunteer contacts anyone.
 */
export interface CandidateVolunteerHistory {
  tasksCompleted: number;
  lastCompletedAt: string | null;
  sameCreator: boolean;
  sharedSkills: string[];
  /**
   * 20260923120000: they asked for volunteer quests (quest_interest). It can be
   * the whole reason they are here, with tasksCompleted 0.
   */
  askedForVolunteer: boolean;
}

/**
 * Narrow the jsonb column. It fails closed: without a positive task count AND
 * without an explicit ask, it reads as "not a volunteer signal", because a wrong
 * badge would put an Invite button in front of someone it does not apply to.
 */
export function parseVolunteerHistory(raw: unknown): CandidateVolunteerHistory | null {
  if (raw === null || typeof raw !== "object" || Array.isArray(raw)) return null;
  const r = raw as Record<string, unknown>;
  const asked = r.askedForVolunteer === true;
  const tasks = typeof r.tasksCompleted === "number" && r.tasksCompleted > 0 ? r.tasksCompleted : 0;
  if (tasks === 0 && !asked) return null;
  return {
    tasksCompleted: tasks,
    lastCompletedAt: typeof r.lastCompletedAt === "string" ? r.lastCompletedAt : null,
    sameCreator: r.sameCreator === true,
    sharedSkills: Array.isArray(r.sharedSkills)
      ? r.sharedSkills.filter((s): s is string => typeof s === "string")
      : [],
    askedForVolunteer: asked,
  };
}
